var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInsuranceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "icon insurance",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.275 207.649c-7.146 0-9.448 3.273-9.448 3.273v12.317s.748 5.9 9.448 8.41c8.346-2.236 9.321-8.092 9.321-8.092v-12.635s-2.351-3.273-9.321-3.273z",
    style: {
      stroke: "none"
    },
    transform: "translate(-274.032 -207.649)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M286.275 208.649c-3.39 0-5.562.783-6.789 1.44-.875.468-1.403.94-1.66 1.204v11.868c.096.53 1.139 5.23 8.459 7.448 3.054-.865 5.377-2.326 6.907-4.347 1.018-1.344 1.337-2.518 1.404-2.808v-12.157c-.26-.266-.79-.738-1.657-1.207-1.217-.657-3.36-1.441-6.664-1.441m0-1c6.97 0 9.321 3.273 9.321 3.273v12.634s-.975 5.856-9.321 8.093c-8.7-2.51-9.448-8.41-9.448-8.41v-12.317s2.302-3.273 9.448-3.273z",
    transform: "translate(-274.032 -207.649)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 3.753 1.523 2.23 3.1 3.808 6.908 0l1.523 1.523-3.807 3.808L3.1 6.854z",
    transform: "translate(8 8)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsuranceIcon);
export default __webpack_public_path__ + "static/media/insurance-icon.a3f71934631708593075bd65b79c3e10.svg";
export { ForwardRef as ReactComponent };